import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { TechnicienGuard } from '../core/guards/technicien.guard';

export const TECH_ROUTES: Routes = [
  {
    path: 'tech/interventions',
    loadComponent: () => import('../features/tech/interventions/list/list.component').then(m => m.TechInterventionsListComponent),
    canActivate: [AuthGuard, TechnicienGuard],
  },
  {
    path: 'tech/sticks/:id/diagnostic',
    loadComponent: () => import('../features/tech/sticks/diagnostic/diagnostic.component').then(m => m.StickDiagnosticComponent),
    canActivate: [AuthGuard, TechnicienGuard],
  },
  {
    path: 'tech/stale-devices',
    loadComponent: () => import('../features/tech/stale-devices/list/list.component').then(m => m.StaleDevicesListComponent),
    canActivate: [AuthGuard, TechnicienGuard],
  },
];
